import { ConvertedCurrencyValue, FlexItemFlexible, FlexSpaceBetween, SpacedLongDash } from '@mews-commander/ui';
import { Typography } from '@optimus-web/core';
import { UnicodeEntity } from '@mews/enums';
import { LocalizedProperty, useFeatureFlag } from '@mews/framework';
import { Reservation, Service } from '@mews-commander/data-access';
import { FeatureFlag } from '@mews-commander/enums';
import { AccountFullName } from '../../../../../components/AccountFullName';
import { TotalAmountAndCount } from '../../../../../types';
import { ServiceName } from '../../../../../../../components';
import { FloatLeftLabel } from './style';

interface ProductOrderLabelProps {
    accountId: string;
    names: Service['names'];
    totalAmountAndCount: TotalAmountAndCount;
    serviceOrderNote?: string;
    linkedReservation?: Reservation;
}

export const ProductOrderLabel: React.FC<ProductOrderLabelProps> = ({
    accountId,
    serviceOrderNote,
    names,
    totalAmountAndCount,
    linkedReservation,
}) => {
    const linkProductsToReservationsEnabled = useFeatureFlag(FeatureFlag.linkProductsToReservationsEnabled);

    return (
        <FlexSpaceBetween>
            <FlexItemFlexible>
                <FloatLeftLabel as="div">
                    <LocalizedProperty property={names} />
                </FloatLeftLabel>
                <Typography textStyle="bodyMediumStrong" variant="secondary" as="div">
                    {SpacedLongDash}
                    <AccountFullName accountId={accountId} />
                    {SpacedLongDash}
                    {serviceOrderNote ? (
                        <>
                            {serviceOrderNote}
                            {SpacedLongDash}
                        </>
                    ) : null}
                    {linkedReservation && linkProductsToReservationsEnabled ? (
                        <>
                            <ServiceName id={linkedReservation.serviceId} /> {linkedReservation.number}
                            {SpacedLongDash}
                        </>
                    ) : null}
                    {totalAmountAndCount.unitCount}
                    {UnicodeEntity.MultiplicationSign}
                </Typography>
            </FlexItemFlexible>
            <div>
                <ConvertedCurrencyValue amount={totalAmountAndCount.amount} />
            </div>
        </FlexSpaceBetween>
    );
};
